import { AccessObjectSourceTag } from './AccessObjectSourceTag';
import { AccessTypeTag } from './AccessTypeTag';
import { ColumnType } from 'antd/es/table';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { SanitizedHtml } from '@ui/general';
import { SonarText } from '@ui/text';
import { When } from 'react-if';

import { AccessAuditDetails, AccessObjectSource, AccessType, ObjectPermission } from '@sonar-software/sonar-core';
import { objectPermissionLabels, PermissionsTag } from './columns/PermissionsTag';

type ColumnDefinition = ColumnType<AccessAuditDetails>;

export const accessNameColumn: ColumnDefinition = {
	dataIndex: 'accessName',
	fixed: 'left',
	key: 'accessName',
	title: COPY_SPECIFIC.ACCESS_NAME,
	width: 300
};

export const accessTypeColumn: ColumnDefinition = {
	dataIndex: 'accessType',
	fixed: 'left',
	key: 'accessType',
	render: (accessType: AccessType, record) => <AccessTypeTag
		accessType={ accessType }
		disabled={ record.isActive === undefined ? false : !record.isActive } />,
	title: COPY_SPECIFIC.ACCESS_TYPE,
	width: 160
};

export const accessObjectSourceColumn: ColumnDefinition = {
	dataIndex: 'accessObjectSource',
	key: 'accessObjectSource',
	render: (accessObjectSource: AccessObjectSource) =>
		<AccessObjectSourceTag accessObjectSource={ accessObjectSource } />,
	title: COPY_SPECIFIC.ACCESS_OBJECT_SOURCE,
	width: 200
};

export const permissionsColumn: ColumnDefinition = {
	dataIndex: 'permissions',
	fixed: 'left',
	key: 'permissions',
	render: (permissions: Record<ObjectPermission, string>) =>
		<PermissionsTag
			permissions={ permissions } />,
	title: COPY_SPECIFIC.PERMISSIONS,
	width: 160
};

export const permissionSourceColumn: ColumnDefinition = {
	dataIndex: 'permissions',
	key: 'permissionSource',
	render: (permissions: Record<ObjectPermission, string>) =>
		<div>{ Object.entries(permissions).reduce((acc, [ key, value ]) =>
			(value ?
				<>
					<When condition={ Boolean(acc) }>
						{ acc }
						<SanitizedHtml
							as='span'
							html={ ', ' } />
					</When>
					<SonarText weight='semibold'>
						{ objectPermissionLabels[ key as ObjectPermission ] }
						<SanitizedHtml
							as='span'
							html={ ': ' } />
					</SonarText>
					<SonarText>
						{ value }
					</SonarText>
				</> :
				acc), null) }
		</div>,
	title: COPY_SPECIFIC.PERMISSION_SOURCE
};

export function getColumns(): Array<ColumnDefinition> {
	return [
		accessNameColumn,
		accessTypeColumn,
		accessObjectSourceColumn,
		permissionsColumn,
		permissionSourceColumn
	];
}
